<template src="./index.html"></template>
<script>
	import {
		comMapping
	} from '@/components/util/Function/comMapping';
	import {
		getdata
	} from './data.js';
	import config from '../../../../../../../../configHttp'
	import {
		fangwxxpage,
		fangwxxsave,
		fangwxxupdate,
		fangwxxdelete,
		queryByCompanyFcTdShenb,
		queryCompanyNo,
		startTaxGather
	} from '../../../../../../../api/cztds.js';
	export default {
		name: '',
		components: {},
		props: {
			invoicediag: {
				type: Boolean,
				default: false
			},
			mxsearch: {
				type: Object,
				default: {}
			},
			paramsx: {
				type: Object,
				default: {}
			},
			shoudata: {
				type: Number,
				default: 2
			},
			outlistx: {
				type: Object,
				default: {}
			}
		},
		data: function() {
			return {
				maplist: [{
						value: null,
						item: '未采集'
					},
					{
						value: 1,
						item: '未采集'
					},
					{
						value: 2,
						item: '采集成功'
					},
					{
						value: 3,
						item: '采集失败'
					},
					{
						value: 4,
						item: '采集中'
					}
				],
				select_error: false,
				title: '新增登记',
				radio: {},
				cjjz: comMapping.$czfwlist,
				copyinvoice: false,
				headData: getdata().headData,
				pagination: getdata().pagination,
				tableData: [{}],
				value2: '',
				copyinvoices: false,
				dropDown: [],
        formList1: getdata().formList1,
        formList2: getdata().formList2,
        formList3: getdata().formList3,
        formList4: getdata().formList4,
				formdata: getdata().formdata,
				options: [],
				index: [],
				lebal: '',
				codeList: [],
			};
		},
		watch: {
			shoudata: function(indexVal, oldVal) {
				if (indexVal > 1) {
					this.page();
					this.title = '新增登记';
					this.Period();
				} else {
					this.copyinvoice = false;
					this.title = '修改登记';
					this.Period();
				}
			}
		},
		created() {
			this.page();
			if (config.company == 'hls') {
				this.code()
			}
		},
		mounted() {
			this.uetiu();
		},
		methods: {
			Shui(e) {
				this.$showConfirm({
					message: "是否上传税源至税局?",
					title: "标题",
				}).then((res) => {
					if (res == "confirm") {
						let params = {
							type: '5',
							detailIds: e.id
						}
						startTaxGather(params).then(res => {
							if (res.data.code == 1) {
								this.page();
							} else {
								this.$message.error(res.data.msg)
							}
						})
					}
				});
			},
			code() {
				queryCompanyNo().then(res => {
					this.codeList = res.data.data
				})
			},
			Period() {
				this.dropDown = [];
				let params = {
					companyNo: this.outlistx.companyNo,
					suosq: this.outlistx.suosq,
					type: 'ccxwfccj'
				};
				queryByCompanyFcTdShenb(params).then(res => {
					if (res.data.code == 1) {
						res.data.data.map(item => {
							this.dropDown.push({
								value: item.suossqz,
								label: item.suossqz
							});
						});
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			uetiu() {
				let UrbanData = window.$UrbanData_mb || window.$UrbanData;
				keyt(UrbanData);

				function keyt(data) {
					data.map(item => {
						item.value = item.label;
						if (item.children) {
							keyt(item.children);
						}
					});
				}

				let data = JSON.parse(JSON.stringify(UrbanData));
				this.options = data.map(item => {
					item.children.map(item1 => {
						item1.children.map(item2 => {
							delete item2.children;
						});
					});
					return item;
				});
			},
			shuiebz(e) {
				let codeNum = 0
				if (this.paramsx.sectionSpan == "" || this.paramsx.sectionSpan == undefined || this.paramsx.sectionSpan ==
					null) {
					let nums = this.paramsx.suosqqz.split('~')
					nums[0] = nums[0].split('-')
					nums[1] = nums[1].split('-')
					codeNum = nums[1][nums[1].length - 2] - nums[0][nums[0].length - 2] + 1
				} else {
					codeNum = this.paramsx.sectionSpan
				}

				// let isfalse = false
				// if(this.codeList.length!=0&&this.paramsx.fangcyt=='1'){
				// this.codeList.map(item=>{
				// if(item==this.outlistx.companyNo){
				console.log(this.paramsx.fangcyz)
				console.log(this.paramsx.chuzfcyz)
				console.log(this.paramsx.jisbl)
				console.log(codeNum)
				this.paramsx.yingnse = this.toFixed((this.paramsx.fangcyz - this.paramsx.chuzfcyz) * (this.paramsx.jisbl /
					12 * codeNum) * 0.012, 2);
				// isfalse = true
				// }
				// })
				// }else{
				// this.paramsx.yingnse = Number(this.paramsx.fangcyz) * (1 - this.paramsx.jisbl) * 0.012;
				// }
				// if(!isfalse){
				// this.paramsx.yingnse = Number(this.paramsx.fangcyz) * (1 - this.paramsx.jisbl) * 0.012;
				// }
				let amount = 0;
				this.paramsx.jianms.forEach((item, index) => {
					if (item.jianmje != '' && item.jianmqsyf != '' && item.jianmqsyf != null && item.jianmzzyf !=
						'' && item.jianmzzyf != null) {
						console.log(11111)
						let times = 1;
						let start = item.jianmqsyf.substring(5, 7);
						let stop = item.jianmzzyf.substring(5, 7);
						if (start <= stop) {
							times = stop - start == 0 ? 1 : stop - start + 1;
						} else {
							let centre = item.jianmqsyf;
							item.jianmqsyf = item.jianmzzyf;
							item.jianmzzyf = centre;
							times = stop - start + 1;
						}
						amount += Number(item.jianmje) * times;
						console.log(amount)

					}
				});
				if (this.outlistx.lflszc == 'Y') {
					this.paramsx.liuslfjmse = (Number(this.paramsx.yingnse) - amount) / 2;
				}
				this.paramsx.benqybtse = Number(this.paramsx.yingnse) - Number(this.paramsx.liuslfjmse) - Number(this
					.paramsx.benqyjse) - amount;
			},
			nextxx() {
				if (this.formdata.fangwzldzShi == '') {
					this.select_error = true;
					this.$refs.taxform.submitForm();
				} else {
					this.$refs.taxform.submitForm();
				}
			},
			alone() {
				if (this.formdata.fangwzldzShi == '') {
					this.select_error = true;
				}
			},
			oucz() {
				this.page();
				this.copyinvoice = true;
			},
			handleChange(e) {
				this.formdata.fangwzldzXiangz = '';
				this.select_error = false;
				let index = 0;
				let UrbanData = window.$UrbanData_mb || window.$UrbanData;
				this.Urban(UrbanData, e, index);
				this.formList2[1].selectval = this.index;
			},
			Urban(list, e, index) {
				list.map(item => {
					if (item.value == e[index]) {
						if (index < 2) {
							index++;
							this.Urban(item.children, e, index);
						} else {
							this.index = item.children;
						}
					}
				});
			},
			remove() {
				if (this.value2 == 2) {
					this.$showConfirm({
						message: '确认删除?'
					}).then(res => {
						if (res == 'confirm') {
							let params = {
								id: this.formdata.id
							};
							fangwxxdelete(params).then(res => {
								if (res.data.code == 1) {
									this.copyinvoices = false;
									this.page();
								} else {
									this.$message.error(res.data.msg);
								}
							});
						}
					});
				} else {
					this.copyinvoices = false;
				}
			},
			xq(e) {
        this.formList1=getdata().formList1
        this.formList2=getdata().formList2
        this.formList3=getdata().formList3
        this.formList4=getdata().formList4
				this.formdata = JSON.parse(JSON.stringify(e));
				this.formdata.fangwzldzShi = [e.fangwzldzSheng, e.fangwzldzShi, e.fangwzldzXian];
				this.copyinvoices = true;
				this.info();
				this.value2 = 2;
			},
			getdata() {
				let outx = JSON.parse(JSON.stringify(this.formdata));
				outx.nsrsbh = this.outlistx.nsrsbh;
				outx.fangwzldzSheng = outx.fangwzldzShi[0];
				outx.fangwzldzXian = outx.fangwzldzShi[2];
				outx.fangwzldzShi = outx.fangwzldzShi[1];
				let params = outx;
				if (this.value2 == 2) {
					fangwxxupdate(params).then(res => {
						if (res.data.code == 1) {
							this.copyinvoices = false;
							this.page();
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else {
					fangwxxsave(params).then(res => {
						if (res.data.code == 1) {
							this.copyinvoices = false;
							this.page();
						} else {
							this.$message.error(res.data.msg);
						}
					});
				}
			},
			xzzt() {
				this.formList1=getdata().formList1
				this.formList2=getdata().formList2
				this.formList3=getdata().formList3
				this.formList4=getdata().formList4
				const index = this.formList4.findIndex(item => item.prop === 'bgsj');
				if (index !== -1) {
					this.formList4.splice(index, 1);
				}
				this.formdata.fangwzldzXiangz = '';
				this.select_error = false;
				this.info();
				this.formdata = getdata().formdata
				Object.keys(this.formdata).map(key => {
					if (key == 'dailrysfzlx') {
						this.formdata[key] = '201';
					} else if (key == 'nsywYxqz') {
						this.formdata[key] = '2099-12-31';
					} else {
						this.formdata[key] = '';
					}
				});
				this.formdata = JSON.parse(JSON.stringify(this.formdata))
				this.copyinvoices = true;
				this.value2 = 1;
				this.$refs.taxform.clearValidate();
			},
			info() {
				this.formList1.map(item => {
					if (item.prop == 'nsrlx') {
						item.selectval = [];
						this.mxsearch.cjjzNsrxz.map(item1 => {
							item.selectval.push(item1);
						});
					} else if (item.prop == 'fangcyt') {
						item.selectval = [];
						this.mxsearch.cjjzFcyt.map(item1 => {
							item.selectval.push(item1);
						});
					} else if (item.prop == 'cqzhlx') {
						item.selectval = [];
						this.mxsearch.fcsCqzhlb.map(item1 => {
							item.selectval.push(item1);
						});
					}
				});
			},
			nextque() {
				Object.keys(this.radio).map(key => {
					this.paramsx[key] = this.radio[key];
				});
				this.copyinvoice = false;
				this.radio = {};
				if (this.paramsx.sectionSpan || this.paramsx.suosqqz) {
					this.shuiebz()
				}

			},
			page() {
				let params = {
					nsrsbh: this.outlistx.nsrsbh,
					size: this.pagination.pageSize,
					current: this.pagination.pageNum
				};
				fangwxxpage(params).then(res => {
					if (res.data.code == 1) {
						res.data.data.records.map(item => {
							if (item.nsrlx) {
								this.mxsearch.cjjzNsrxz.map(item1 => {
									if (item.nsrlx == item1.value) {
										item.nsrlxx = item1.label;
									}
								});
							}
							if (item.fangcyt) {
								this.mxsearch.cjjzFcyt.map(item1 => {
									if (item.fangcyt == item1.value) {
										item.fangcytx = item1.label;
									}
								});
							}
							if (item.bianglx) {
								this.mxsearch.cjjzTdbglxNsywzz.map(item1 => {
									if (item.bianglx == item1.value) {
										item.bianglxx = item1.label;
									}
								});
								this.mxsearch.cjjzTdbglxXxxbg.map(item1 => {
									if (item.bianglx == item1.value) {
										item.bianglxx = item1.label;
									}
								});
							}
						});
						this.tableData = res.data.data.records;
						this.pagination.total = res.data.data.total;
						if (this.invoicediag == true) {
							this.copyinvoice = true;
						}
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			closediag() {
				this.$emit('closediag', '');
			},
			nextxz() {
				if (this.paramsx.fangcbh == '' || this.paramsx.fangcyz == '' || this.paramsx.fangcyt == '' || !this.paramsx
					.suosqqz || this.paramsx.suosqqz == '') {
					if (this.paramsx.fangcbh == '') {
						return this.$message.error('请选择您需要的住房信息');
					} else {
						return this.$message.error('请补充完整必填部分');
					}
				}
				this.$emit('nextxz', this.paramsx);
			},
			currentChange() {},
			sizechange() {}
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
</style>